import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


const DescModal = ({ show, handleClose, movie }) => {
  if (!movie) {
    // If movie is null, return null or some fallback UI
    return null;
  }

  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header closeButton={false}>
        <Modal.Title className="text-center">{movie.title} Description</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="text-center">{movie.overview}</div>
      </Modal.Body>
      <Modal.Footer className="justify-content-center">
        <Button className="w-100 btn-warning" variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DescModal;
